import React from 'react';
import { FirstSectionContact } from './components/firstSection';

export const ContactPage = () => {
    return (
        <div>
            <FirstSectionContact/>
        </div>
    );
};

